import { OverlayView } from "@react-google-maps/api";
import DSBox from "../../system-design/DSBox";
import { MapCollection } from "../../../api/admin";
import { parseCloudinaryUrl } from "../../../utils/util";

type CollectionMarkerProps = {
  collection: MapCollection;
};

const CollectionMarker = ({ collection }: CollectionMarkerProps) => {
  if (!collection.randomLocation || !collection.coverUrl) return null;

  return (
    <OverlayView
      position={{
        lat: collection.randomLocation.latitude,
        lng: collection.randomLocation.longitude,
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <DSBox
        sx={{
          right: "11px",
          borderRadius: "50%",
          width: 24,
          height: 24,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <img
          src={parseCloudinaryUrl({ url: collection.coverUrl, size: 48 })}
          alt="Collection cover image"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </DSBox>
    </OverlayView>
  );
};

export default CollectionMarker;
